module.exports = __webpack_public_path__ + "static/media/1.b426512b.JPG";